import { useContext } from 'react';
import { LangContext } from './LangContext';

const translations = {
  en: {
    home: "Home",
    about: "About",
    boutique: "Shop",
    activities: "Activities",
    Restaurant: "Restaurant",
    Chalet: "Chalet",
    Musée: "Museum",
    Huillerie: "Oil Mill",
    Académie: "Academy",
    contact: "Contact",
    voirPlus: "View Details",
    MorePhotos: "View More Photos",
    MoreProducts: "Explore More Products",
    ViewEvents: "View All Events",
    MoreInfo: "More Info",
    contactUs: "Contact us",
    alreadysent: "Your message has been sent. Thank you!",
    BookaTable: "Book a Table",
    BookaTable2: "Book a Table",
    Sending: "Sending",
    SearchProducts: "Search products",
    FilterByPrice: "Filter by price",
    FilterByColor: "Filter By Color",
    AllColor: "All Color",
    AllPrice: "All Price",
    homeSectionTitle: "In the heart of the Tabarka mountains, a breathtaking view of a magnificent dam.",
    homeSectionDescription: "Domaine Numidia is a unique place that reflects the authenticity and cultural richness of the region. Between nature, tradition and gastronomy, it invites you to live an unforgettable experience.",
    homeFeature1: "A museum tracing the daily life and heritage of Tabarka.",
    homeFeature2: "A restaurant with local flavors, enhanced by talented chefs.",
    homeFeature3: "An oil mill and boutique offering olive oil, honey and artisanal soaps.",
    homeSectionConclusion: "Domaine Numidia is much more than a space: it's an immersion into the soul of Tabarka, where hospitality, know-how and natural beauty meet.",
    whyUsTitle: "Why Choose Us",
    whyUsSubtitle: "Why Choose Domaine Numidya",
    whyUsFeature1Title: "Authenticity and Heritage",
    whyUsFeature1Desc: "A museum and traditional architecture that immerse you in the cultural richness and daily life of Tabarka.",
    whyUsFeature2Title: "Local Flavors",
    whyUsFeature2Desc: "A restaurant where our professional chefs enhance local products with passion and creativity.",
    whyUsFeature3Title: "Nature and Well-being",
    whyUsFeature3Desc: "An exceptional setting in the mountains, a natural products store for a healthy and authentic experience.",
    productsTitle: "Our Products",
    productsSubtitle: "Discover our specialties",
    noProducts: "No products available at the moment",
    chaletTitle: "Our Chalet", 
    chaletSubtitle: "Some photos of our space",
    noChaletImages: "No images available at the moment",
    eventsTitle: "Events",
    eventsSubtitle: "Our upcoming events", 
    noEvents: "No upcoming events at the moment",  
    productsPageTitle: "Our products",
    noProductsFound: "No products found matching your criteria", 
    menuTitle: "Menu",
    menuSubtitle: "Discover our delicious menu",
    noDishes: "No dishes available in this category",  
    specialsTitle: "Specials",
    specialsSubtitle: "Check Our Specials",  
    special1Title: "Traditional Couscous",
    special1Desc: "A traditional dish made with fresh ingredients and authentic flavors",
    special1Detail: "Our signature dish prepared with locally sourced organic vegetables and slow-cooked lamb. Served with traditional broth and homemade harissa.", 
    special2Title: "Grilled Sea Bass", 
    special2Desc: "A fresh seafood dish, perfectly grilled with aromatic herbs",
    special2Detail: "Caught daily from the Tabarka coast, grilled to perfection with olive oil, thyme, and rosemary. Served with seasonal vegetables and lemon sauce.",  
    special3Title: "Mechouia Salad",
    special3Desc: "A fresh and colorful salad blending grilled vegetables, authentic flavors, and local ingredients",
    special3Detail: "A classic Tunisian salad made with fire-roasted peppers, tomatoes, and onions, topped with quality tuna and hard-boiled eggs. Dressed with olive oil and cumin.",
    special4Title: "Lamb Tagine",
    special4Desc: "A tender meat dish, slowly cooked with sweet and spiced flavors",
    special4Detail: "Tender lamb cooked for hours with traditional spices, dried prunes, toasted almonds, and a touch of honey. Served with crusty bread.",    
    special5Title: "Baklawa Assortment",
    special5Desc: "A traditional dessert with authentic flavors, a true symbol of local delicacy",
    special5Detail: "Homemade baklawa with pistachios, almonds, and walnuts. Prepared following ancestral recipes and soaked in orange blossom honey syrup.",    
    chefsTitle: "Chefs",
    chefsSubtitle: "Our Professional Chefs",    
    galleryTitle: "Gallery",
    gallerySubtitle: "Some photos of our Restaurant",
    noRestaurantImages: "No images available for the restaurant.",
    specialTab1: "Traditional",
    specialTab2: "Seafood", 
    specialTab3: "Salads",
    specialTab4: "Meat",
    specialTab5: "Desserts",

    // Filtres produits
    allProducts: "All",
    honeyCategory: "Honey",
    oilCategory: "Oil", 
    soapCategory: "Soap",
    
    // Formulaires
    namePlaceholder: "Your Name",
    emailPlaceholder: "Your Email",
    phonePlaceholder: "Your Phone",
    
    // Chalet Gallery
    chaletGalleryTitle: "Gallery",
    chaletGallerySubtitle: "Traditional Tabarka Chalet",
    loadingImages: "Loading images...",
    noCategoryImages: "No images available for this category.",
    
    // Musée
    museumTitle: "Museum",
    museumSubtitle: "Discover the daily life of Tabarka",
    ourMuseum: "Our Museum",
    museumTheme: "History and traditions",
    museumDescription: "Immerse yourself in the history and culture of Tabarka through our museum, which traces the daily life, traditions and unique heritage of the region.",
    museumFeature1: "Explore typical objects and artifacts of Tabarka.",
    museumFeature2: "Discover local customs and traditional crafts.",
    museumFeature3: "Learn about the history of the region through interactive exhibitions.",
    museumConclusion: "Our museum offers an immersive experience for young and old, a journey to the heart of the soul of Tabarka, meeting its past and its authenticity.",
    
    // Musée Gallery
    museumGalleryTitle: "Gallery",
    museumGallerySubtitle: "Some photos of the Museum",
    noMuseumImages: "No images available for the Museum.",
    
    // Événements
    eventsTitle: "Our Events",
    eventsSubtitle: "Don't miss any event",
    
    // Huilerie Gallery
    oilMillGalleryTitle: "Gallery",
    oilMillGallerySubtitle: "Some photos of the oil mill",
    noOilMillImages: "No images available for the oil mill.",
    
    // Académie
    academyTitle: "Academy",
    academySubtitle: "Learn the art of oil mill and traditional crafts",
    ourAcademy: "Our Academy",
    academyDescription: "Our academy offers unique training in the field of oil mill and local crafts, to pass on the know-how and traditions of Tabarka.",
    academyFeature1: "Learn to produce and select quality olive oil.",
    academyFeature2: "Discover local artisanal techniques.",
    academyFeature3: "Participate in practical and interactive workshops.",
    academyConclusion: "The Domaine Numidia Academy is an enriching experience for all those who wish to learn or improve in the art of oil mill and traditional trades of the region.",
    
    // Spécialités Académie
    academySpecialsTitle: "Specialties",
    academySpecialsSubtitle: "Discover our specialties",
    
    // Formateurs
    trainersTitle: "Trainers",
    trainersSubtitle: "Our professional trainers",
    
    // Académie Gallery
    academyGalleryTitle: "Gallery",
    academyGallerySubtitle: "Some photos of the Academy",
    noAcademyImages: "No images available for the academy.",
    // Academy Specials
    academySpecialsTitle: "Specialties",
    academySpecialsSubtitle: "Discover our specialties",
    
    // Tabs titles
    oilTab: "Oil Mill",
    honeyTab: "Honey", 
    soapTab: "Soap",
    
    // Oil content
    oilTitle: "Participate in practical and interactive workshops.",
    oilDescription: "Learn to produce and select quality olive oil.\nMaster traditional local techniques.\nParticipate in practical and interactive workshops.",
    
    // Honey content  
    honeyTitle: "Learn the essential role of bees and the production of natural honey",
    honeyDescription: "Discover the secrets of traditional beekeeping.\nLearn to harvest and process artisanal honey.\nExplore different varieties and their benefits.",
    
    // Soap content
    soapTitle: "Learn to transform local resources into authentic soaps",
    soapDescription: "Get initiated into natural soap making.\nDiscover local recipes and ingredients.\nCreate your own artisanal products to take home.",

    // Contact section
    locationTitle: "Location:",
    openingHoursTitle: "Opening Hours:",
    openingHours: "Monday-Saturday:<br/>11:00 AM - 11:00 PM",
    callUsTitle: "Call us:",
    subjectPlaceholder: "Subject",
    
    // Days and times
    mondayToSaturday: "Monday-Saturday",
    sunday: "Sunday",
    hours: "11:00 AM - 11:00 PM",
    closed: "Closed",
    sendButton: "Send",

     // Événements - liste
    eventFeature1: "Unique event not to be missed.",
    eventFeature2: "Guaranteed atmosphere and exceptional venue.",
    eventFeature3: "We are looking forward to welcoming you.",
    
    // Pourquoi participer
    whyAttendTitle: "Why Participate",
    whyAttendSubtitle: "Reasons not to miss this event",
    reason1Title: "Unique Atmosphere",
    reason1Desc: "Enjoy an unforgettable experience in an exceptional setting.",
    reason2Title: "Meetings & Networking", 
    reason2Desc: "Connect with people who share the same passions.",
    reason3Title: "Unforgettable Memories",
    reason3Desc: "Leave with memories, photos, and highlights.",
    
    // Chargement
    loading: "Loading...",
    productNotFound: "Product not found.",
    
    // Boutons
    orderButton: "Order",
    viewDetails: "View details",
    
    // Onglets produit
    tabDescription: "Description",
    tabInfo: "Information", 
    tabReviews: "Reviews (50)",
    productDescriptionTitle: "Product description",
    additionalInfoTitle: "Additional information",
    additionalInfoText: "Technical information and additional product details.",
    reviewsTitle: "Customer reviews",
    reviewsText: "Customer reviews section with ratings and comments.",
    
    // Produits similaires
    similarProductsTitle: "Similar Products",
    similarProductsSubtitle: "You may also like",

  // Produit
    priceLabel: "Price:",
    currency: "$",
    
    // Formulaire de commande
    fullName: "Full Name",
    email: "Email",
    phoneNumber: "Phone Number",
    address: "Address",
    quantity: "Quantity",
    
    // Boutons
    cancel: "Cancel",
    confirmOrder: "Confirm Order",
    orderSuccess: "Order confirmed successfully!",
    orderError: "Error placing order. Please try again.",

    productDescription: "Discover this product",
    productDetails: "Product Details",
    SearchProducts: "Search products",
    ourEvents: "Our Events",
    ourProducts: "Our Products",
    welcomeTo: "Welcome to",
    descriptionWelcoming: "A Journey Through Nature, Taste, and Heritage!",
    ourServices: "Our Services",
    newsletterText: "Subscribe to the newsletter to receive our latest news",
    phoneLabel: "Phone:",
    subscribing: "Subscribing...",
    signUp: "Sign Up",
    allRightsReserved: "All Rights Reserved",
    createdBy: "Created by",
    bookingSuccess: "Booking confirmed successfully!",
    namePlaceholder: "Your Name", 
    subscriptionSuccess: "Thank you for subscribing!",
    notAvailable: "(Not available for the moment)",

  

  },
  fr: {
    home: "Accueil",
    about: "À propos",
    boutique: "Boutique",
    activities: "Activités",
    Restaurant: "Restaurant",
    Chalet: "Chalet",
    Musée: "Musée",
    Huillerie: "Huillerie",
    Académie: "Académie",
    contact: "contact",
    BookTable: "Réservez une table",
    voirPlus: "Voir Plus",
    MorePhotos: "Parcourir la galerie",
    MoreProducts: "Explorer nos produits",
    ViewEvents: "Tous les événements",
    MoreInfo: "En savoir plus",
    contactUs: "Nous contacter",
    alreadysent: "Votre message a été envoyé. Merci !",
    BookaTable: "Réserver une table",
    BookaTable2: "Réservation",
    Sending: "En cours",
    SearchProducts: "Rechercher",
    FilterByPrice: "Filter par prix",
    FilterByColor: "Filter par couleur",
    AllColor: "Toutes les couleurs",
    AllPrice: "Tous les prix",
    homeSectionTitle: "Au cœur des montagnes de Tabarka, une vue imprenable sur un magnifique barrage.",
    homeSectionDescription: "Domaine Numidia est un lieu unique qui reflète l'authenticité et la richesse culturelle de la région. Entre nature, tradition et gastronomie, il vous invite à vivre une expérience inoubliable.",
    homeFeature1: "Un musée qui retrace la vie quotidienne et le patrimoine de Tabarka.",
    homeFeature2: "Un restaurant aux saveurs locales, sublimées par des chefs talentueux.",
    homeFeature3: "Une huilerie et une boutique offrant huile d'olive, miel et savons artisanaux.",
    homeSectionConclusion: "Le Domaine Numidia, c'est bien plus qu'un espace : c'est une immersion dans l'âme de Tabarka, où hospitalité, savoir-faire et beauté naturelle se rencontrent.",
    whyUsTitle: "Pourquoi Nous",
    whyUsSubtitle: "Pourquoi Choisir le Domaine Numidya",
    whyUsFeature1Title: "Authenticité et Patrimoine",
    whyUsFeature1Desc: "Un musée et une architecture traditionnelle qui vous plongent dans la richesse culturelle et la vie quotidienne de Tabarka.",
    whyUsFeature2Title: "Saveurs Locales",
    whyUsFeature2Desc: "Un restaurant où nos chefs professionnels subliment les produits du terroir avec passion et créativité.",
    whyUsFeature3Title: "Nature et Bien-être",
    whyUsFeature3Desc: "Un cadre exceptionnel en pleine montagne, une boutique de produits naturels pour une expérience saine et authentique.",
    productsTitle: "Nos Produits",
    productsSubtitle: "Découvrez nos spécialités",
    noProducts: "Aucun produit disponible pour le moment", 
    chaletTitle: "Notre Chalet",
    chaletSubtitle: "Quelques photos de notre espace", 
    noChaletImages: "Aucune image disponible pour le moment",
    eventsTitle: "Événements",
    eventsSubtitle: "Nos prochains rendez-vous",
    noEvents: "Aucun événement à venir pour le moment",
    productsPageTitle: "Nos produits",
    noProductsFound: "Aucun produit ne correspond à vos critères",
    menuTitle: "Menu",
    menuSubtitle: "Découvrez notre délicieux menu",
    noDishes: "Aucun plat disponible dans cette catégorie",
    specialsTitle: "Spécialités",
    specialsSubtitle: "Découvrez nos Spécialités",
    special1Title: "Couscous Traditionnel",
    special1Desc: "Un plat traditionnel préparé avec des ingrédients frais et des saveurs authentiques",
    special1Detail: "Notre plat signature préparé avec des légumes biologiques locaux et de l'agneau mijoté. Servi avec bouillon traditionnel et harissa maison.",
    special2Title: "Loup de Mer Grillée",
    special2Desc: "Un plat de fruits de mer frais, grillé à la perfection avec des herbes aromatiques",
    special2Detail: "Pêché quotidiennement sur la côte de Tabarka, grillé à perfection avec huile d'olive, thym et romarin. Servi avec légumes de saison et sauce citron.",
    special3Title: "Salade Méchouia",
    special3Desc: "Une salade fraîche et colorée, mêlant légumes grillés, saveurs authentiques et ingrédients du terroir",
    special3Detail: "Une salade tunisienne classique à base de poivrons, tomates et oignons grillés au feu de bois, garnie de thon de qualité et d'œufs durs. Assaisonnée à l'huile d'olive et au cumin.",
    special4Title: "Tajine d'Agneau",
    special4Desc: "AUn plat de viande tendre, mijoté lentement avec des saveurs sucrées et épicées",
    special4Detail: "Agneau tendre cuit pendant des heures avec des épices traditionnelles, pruneaux séchés, amandes toastées et une touche de miel. Servi avec pain croustillant.",  
    special5Title: "Assortiment de Baklawa",
    special5Desc: "Un dessert traditionnel aux saveurs authentiques, symbole de la gourmandise locale",
    special5Detail: "Baklawa maison aux pistaches, amandes et noix. Préparée selon des recettes ancestrales et imbibée de sirop de miel à l'eau de fleur d'oranger.",  
    chefsTitle: "Chefs",
    chefsSubtitle: "Nos Chefs Professionnels", 
    galleryTitle: "Gallerie",
    gallerySubtitle: "Quelques photos de notre Restaurant",
    noRestaurantImages: "Aucune image disponible pour le restaurant.",
    specialTab1: "Traditionnel",
    specialTab2: "Fruits de Mer",
    specialTab3: "Salades", 
    specialTab4: "Viandes",
    specialTab5: "Desserts",

    // Filtres produits
    allProducts: "Tous",
    honeyCategory: "Miel",
    oilCategory: "Huile",
    soapCategory: "Savon",
    
    // Formulaires
    namePlaceholder: "Votre Nom",
    emailPlaceholder: "Votre Email",
    phonePlaceholder: "Votre Téléphone",
    
    // Chalet Gallery
    chaletGalleryTitle: "Galerie",
    chaletGallerySubtitle: "Chalet traditionnel de Tabarka",
    loadingImages: "Chargement des images...",
    noCategoryImages: "Aucune image disponible pour cette catégorie.",
    
    // Musée
    museumTitle: "Musée",
    museumSubtitle: "Découvrez la vie quotidienne de Tabarka",
    ourMuseum: "Notre Musée",
    museumTheme: "Histoire et traditions",
    museumDescription: "Plongez dans l'histoire et la culture de Tabarka à travers notre musée, qui retrace la vie quotidienne, les traditions et le patrimoine unique de la région.",
    museumFeature1: "Explorez les objets et artefacts typiques de Tabarka.",
    museumFeature2: "Découvrez les coutumes locales et l'artisanat traditionnel.",
    museumFeature3: "Apprenez l'histoire de la région grâce à des expositions interactives.",
    museumConclusion: "Notre musée offre une expérience immersive pour petits et grands, un voyage au cœur de l'âme de Tabarka, à la rencontre de son passé et de son authenticité.",
    
    // Musée Gallery
    museumGalleryTitle: "Galerie",
    museumGallerySubtitle: "Quelques photos du Musée",
    noMuseumImages: "Aucune image disponible pour le Musée.",
    
    // Événements
    eventsTitle: "Nos Événements",
    eventsSubtitle: "Ne manquez aucun événement",
    
    // Huilerie Gallery
    oilMillGalleryTitle: "Galerie",
    oilMillGallerySubtitle: "Quelques photos de l'huillerie",
    noOilMillImages: "Aucune image disponible pour la huillerie.",
    
    // Académie
    academyTitle: "Académie",
    academySubtitle: "Apprenez l'art de l'huilerie et de l'artisanat traditionnel",
    ourAcademy: "Notre Académie",
    academyDescription: "Notre académie propose des formations uniques dans le domaine de l'huilerie et de l'artisanat local, pour transmettre le savoir-faire et les traditions de Tabarka.",
    academyFeature1: "Apprenez à produire et sélectionner l'huile d'olive de qualité.",
    academyFeature2: "Découvrez les techniques artisanales locales.",
    academyFeature3: "Participez à des ateliers pratiques et interactifs.",
    academyConclusion: "L'Académie du Domaine Numidia est une expérience enrichissante pour tous ceux qui souhaitent s'initier ou se perfectionner dans l'art de l'huilerie et des métiers traditionnels de la région.",
    
    // Spécialités Académie
    academySpecialsTitle: "Spécialités",
    academySpecialsSubtitle: "Découvrez nos spécialités",
    
    // Formateurs
    trainersTitle: "Formateurs",
    trainersSubtitle: "Nos formateurs professionnels",
    
    // Académie Gallery
    academyGalleryTitle: "Galerie",
    academyGallerySubtitle: "Quelques photos de l'Académie",
    noAcademyImages: "Aucune image disponible pour l'académie.",

    // Academy Specials
    academySpecialsTitle: "Spécialités",
    academySpecialsSubtitle: "Découvrez nos spécialités",
    
    // Tabs titles
    oilTab: "Huilerie",
    honeyTab: "Miel",
    soapTab: "Savon",
    
    // Oil content
    oilTitle: "Participez à des ateliers pratiques et interactifs.",
    oilDescription: "Apprenez à produire et sélectionner l'huile d'olive de qualité.\nMaîtrisez les techniques traditionnelles locales.\nParticipez à des ateliers pratiques et interactifs.",
    
    // Honey content
    honeyTitle: "Apprenez le rôle essentiel des abeilles et la fabrication du miel naturel",
    honeyDescription: "Découvrez les secrets de l'apiculture traditionnelle.\nApprenez à récolter et transformer le miel artisanal.\nExplorez les différentes variétés et leurs bienfaits.",
    
    // Soap content
    soapTitle: "Apprenez à transformer les ressources locales en savons authentiques",
    soapDescription: "Initiez-vous à la fabrication de savons naturels.\nDécouvrez les recettes et ingrédients locaux.\nCréez vos propres produits artisanaux à emporter.",

    // Contact section
    locationTitle: "Localisation:",
    openingHoursTitle: "Horaires d'ouverture:",
    openingHours: "Lundi-Samedi:<br/>11h00 - 23h00",
    callUsTitle: "Appelez-nous:",
    subjectPlaceholder: "Objet",
    
    // Days and times
    mondayToSaturday: "Lundi-Samedi",
    sunday: "Dimanche",
    hours: "11h00 - 23h00",
    closed: "Fermé",
    sendButton: "Envoyer",

    // Événements - liste
    eventFeature1: "Événement unique à ne pas manquer.",
    eventFeature2: "Ambiance garantie et lieu exceptionnel.",
    eventFeature3: "On vous attend avec impatience.",
    
    // Pourquoi participer
    whyAttendTitle: "Pourquoi Participer",
    whyAttendSubtitle: "Raisons de ne pas rater cet événement",
    reason1Title: "Ambiance Unique",
    reason1Desc: "Profitez d'une expérience inoubliable dans un cadre exceptionnel.",
    reason2Title: "Rencontres & Réseautage",
    reason2Desc: "Connectez-vous avec des personnes partageant les mêmes passions.",
    reason3Title: "Souvenirs Inoubliables", 
    reason3Desc: "Repartez avec des souvenirs, des photos, et des moments forts.",
    
    // Chargement
    loading: "Chargement...",
    productNotFound: "Produit non trouvé.",
    
    // Boutons
    orderButton: "Commander",
    viewDetails: "Voir détails",
    
    // Onglets produit
    tabDescription: "Description",
    tabInfo: "Informations",
    tabReviews: "Avis (50)",
    productDescriptionTitle: "Description du produit",
    additionalInfoTitle: "Informations complémentaires",
    additionalInfoText: "Informations techniques et détails supplémentaires sur le produit.",
    reviewsTitle: "Avis clients",
    reviewsText: "Section des avis clients avec notation et commentaires.",
    
    // Produits similaires
    similarProductsTitle: "Produits Similaires",
    similarProductsSubtitle: "Vous aimerez aussi",
     // Produit
    priceLabel: "Prix:",
    currency: "€", // ou "$" selon votre devise
    
    // Formulaire de commande
    fullName: "Nom Complet",
    email: "Email",
    phoneNumber: "Numéro de Téléphone", 
    address: "Adresse",
    quantity: "Quantité",
    
    // Boutons
    cancel: "Annuler",
    confirmOrder: "Confirmer la commande",
    orderSuccess: "Commande confirmée avec succès !",
    orderError: "Erreur lors de la commande. Veuillez réessayer.",

    productDescription: "Explorez ce produit",
    productDetails: "Détails du produit",
    ourEvents: "Nos événements",
    ourProducts: "Nos Produits",
    welcomeTo: "Bienvenue à",
    descriptionWelcoming: "Un voyage à travers la nature, les saveurs et le patrimoine!",
    ourServices: "Nos Services",
    newsletterText: "Abonnez-vous à la newsletter pour recevoir nos actualités",
    phoneLabel: "Téléphone :",
    subscribing: "En cours d'abonnement...",
    signUp: "S'inscrire",
    allRightsReserved: "Tous droits réservés",
    createdBy: "Créé par",
    bookingSuccess: "Réservation confirmée avec succès !",
    namePlaceholder: "Votre nom",
    subscriptionSuccess: "Merci pour votre inscription !",
    notAvailable: "(N'est pas diponible pour le moment)",

    
  }
};

export const useTranslation = () => {
  const { lang } = useContext(LangContext);
  
  return {
    t: (key) => translations[lang][key] || key
  };
};